const ONE_HUNDRED_PERCENT = 100;

export default class CommonUtils {
  public static getPercentageValue(value: number): number {
    return Math.round(value * ONE_HUNDRED_PERCENT);
  }
}
